import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// comment this out if switching to json
//import Backend from 'i18next-fluent-backend';

// uncomment for using json
import Backend from "i18next-xhr-backend";

const _localizationfileType = "json";

function getUrlParameter(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

i18n
    .use(Backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        backend: {
            loadPath: "/locales/dfid-mfalogin/{{lng}}/{{ns}}." + _localizationfileType,
            keySeparator: ".",
            customHeaders: {
                "Content-Type": "application/json"
            }
        },
        lng: getUrlParameter('cc'), // user culture 
        fallbackLng: "dev", // fallback Culture, 

        keySeparator: ".",

        interpolation: {
            escapeValue: false // react already safes from xss
        },
        react: {
            wait: true,
            useSuspense: false
        },
        ns: ["MFALogin"] //load this ns right away
    });

export default i18n;